import { history } from 'Shared/utils/routing'

export const setSearchParam = (name: string, value: string | number | boolean) => {
	const params = new URLSearchParams(window.location.search)
	params.set(name, value.toString())
	replace(params)
}

export const deleteMultipleSearchParams = (names: string[]) => {
	const params = new URLSearchParams(window.location.search)
	names.forEach((name) => {
		params.delete(name)
	})
	replace(params)
}

export const deleteSearchParam = (name: string) => {
	const params = new URLSearchParams(window.location.search)
	params.delete(name)
	replace(params)
}

export const deleteAllSearchParams = () => {
	replace(new URLSearchParams())
}

export const updateUrlParams = (key: string, value: Key | boolean) => {
	const url = new URL(window.location.href)
	const params = new URLSearchParams(url.search)

	params.set(key, value.toString())
	url.search = params.toString()
	replace(params)
}

export const updateMultipleUrlParams = (keys: string[], value: Key[] | boolean[]) => {
	const url = new URL(window.location.href)
	const params = new URLSearchParams(url.search)
	keys.forEach((name, index) => {
		params.set(name, value[index].toString())
	})
	url.search = params.toString()
	replace(params)
}

export const appendSearchParam = (name: string, value: string | number | boolean) => {
	const params = new URLSearchParams(window.location.search)
	params.append(name, value.toString())
	replace(params)
}

export const getAllSearchParams = () => {
	const params = new URLSearchParams(window.location.search)
	const allParams: Record<string, string[]> = {}
	params.forEach((value, key) => {
		if (allParams[key]?.length) {
			allParams[key].push(value)
			return
		}
		allParams[key] = [value]
	})
	return allParams
}

export const getSearchParam = (name: string) => {
	const urlParams = new URLSearchParams(window.location.search)
	return urlParams.get(name)
}

export const getAllSearchParam = (name: string) => {
	const urlParams = new URLSearchParams(window.location.search)
	return urlParams.getAll(name)
}

const replace = (params: URLSearchParams) => {
	history.replace({ pathname: window.location.pathname, search: params.toString() })
}

export const isRelative = (path: string) => {
	return !path.includes('http')
}

export const fromStringToParams = (stringParams: string): { [key: string]: string } => {
	const withoutQOrH = stringParams.substring(1)

	if (!withoutQOrH) {
		return {}
	}

	const params: Record<string, string> = {}
	const vars = withoutQOrH.split('&')

	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split('=')
		params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
	}

	return params
}

export const isEmpty = (obj?: {}) => {
	if (typeof obj === 'undefined' || !obj) {
		return true
	}

	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			return false
		}
	}
	return true
}

export const fromParamsToString = (paramsObject: { [key: string]: string }) => {
	if (isEmpty(paramsObject)) {
		return ''
	}

	const params = Object.keys(paramsObject).map((name) => {
		return `${name}=${encodeURIComponent(paramsObject[name])}`
	})

	return '?' + params.join('&')
}

export const getDomainPort = () => {
	const url = window.location.href
	const arr = url.split('/')
	return arr[0] + '//' + arr[2]
}

export const getCurrentUrl = () => window.location.href

export const redirectToUrl = (url: string) => window.location.replace(url)

export const openNewTab = (url: string) => window.open(url, '_blank', 'noopener,noreferrer')
